
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace",
      function () {
        return require("private-next-pages/[locale]/marketplace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace"])
      });
    }
  